import { createContext, useMemo } from "react";

import type { ReactNode } from "react";

import type { CompanyLogo } from "types/company";

interface ShipperShipmentPageContextProps {
  children: ReactNode;
  shipment: ShipperCondensedShipment | undefined;
  onRefresh: VoidFunction;
  error: UIError | null;
  logoByCompanyId: Map<number, CompanyLogo>;
  scoreByQuoteId: Map<number, ShipperQuoteScore>;
  scoresError: UIError;
}

interface ShipperShipmentPageContextState {
  onRefresh: VoidFunction | null;
  shipment: ShipperCondensedShipment | undefined;
  error: UIError | null;
  logoByCompanyId: Map<number, CompanyLogo>;
  scoreByQuoteId: Map<number, ShipperQuoteScore>;
  scoresError: UIError;
}

export const shipperShipmentPageContext =
  createContext<ShipperShipmentPageContextState>({
    onRefresh: null,
    shipment: undefined,
    error: null,
    logoByCompanyId: new Map(),
    scoreByQuoteId: new Map(),
    scoresError: null,
  });

export function ShipperShipmentPageProvider(
  props: ShipperShipmentPageContextProps,
) {
  const {
    children,
    shipment,
    onRefresh,
    error,
    logoByCompanyId,
    scoreByQuoteId,
    scoresError,
  } = props;

  const value = useMemo(
    () => ({
      shipment,
      onRefresh,
      error,
      logoByCompanyId,
      scoreByQuoteId,
      scoresError,
    }),
    [shipment, onRefresh, error, logoByCompanyId, scoreByQuoteId, scoresError],
  );

  return (
    <shipperShipmentPageContext.Provider value={value}>
      {children}
    </shipperShipmentPageContext.Provider>
  );
}
